import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { SignEstimateContainer } from '../sign-estimate';
import styles from './signature-text.less';

interface Props {
    container: SignEstimateContainer;
    isSubmitting: boolean;
}

@observer
export class SignatureText extends React.Component<Props> {
    @observable private signatureText = '';

    handleInput = (ev: React.ChangeEvent<HTMLInputElement>) => {
        this.signatureText = ev.target.value;
    };

    handleSubmit = () => {
        this.props.container.handleSubmit(this.signatureText);
    };

    render() {
        const { isSubmitting } = this.props;
        return (
            <Dialog
                open
                onClose={this.props.container.handleClose}
                disableEscapeKeyDown
                aria-labelledby="sign-estimate-dialog-title"
            >
                <DialogTitle
                    id="sign-estimate-dialog-title"
                    disableTypography
                    className={styles.title}
                >
                    Sign to accept estimate
                </DialogTitle>

                <DialogContent>
                    <input
                        value={this.signatureText}
                        onChange={this.handleInput}
                        className={styles.input}
                        autoFocus
                        placeholder="Type your name"
                    />
                    <p className={styles.text}>
                        By entering your name above and clicking on the “Agree and Submit” button
                        you agree that you have reviewed and approved this document. You further
                        agree that entering your name will have the same force and effect as
                        your written signature.
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.handleSubmit}
                        color="primary"
                        className={styles.submitButton}
                        disabled={isSubmitting}
                    >
                        Agree and Submit
                    </Button>
                </DialogActions>
                <button
                    className={styles.close}
                    onClick={this.props.container.handleClose}
                ></button>
            </Dialog>
        );
    }
}
